import React, { Component } from 'react'
import { Message } from 'primereact/message';

export default class IgigInfoMessage extends Component {
    render() {
        return (
            <>
                {
                    this.props.message != null && this.props.message.length > 0 ?
                        <div className="p-col-12 p-md-3 services-not-found mt-2">
                            <Message severity="info" text={this.props.message} />
                        </div>
                        : null
                }
            </>

        )
    }
}
